<template>
  <div class="container">
    <div v-if="detail">
      <Form :label-width="100" class="attach-form">
        <FormItem label="研发经理">
          {{ detail.creatorName }}
        </FormItem>
        <FormItem label="联系方式">
          {{ detail.creatorMobile }}
        </FormItem>
      </Form>
    </div>
    <!-- 研发经理配置 -->
    <div>
      <Row class="detail-header">
        <span>研发经理配置</span>
      </Row>
      <div>
        <Form v-if="detail" class="attach-form" :label-width="100" style="width:600px;">
          <FormItem label="重案级别">
            {{ detail.level }}
          </FormItem>
          <div v-if="developForm.level!='D'">
            <FormItem label="建议起诉标的">
              <Row>
                {{ detail.minAmount }}-{{ detail.maxAmount }}
              </Row>
            </FormItem>
            <FormItem label="推荐管辖法院">
              <div>
                {{ detail.courtJurisdiction }}
              </div>
            </FormItem>
            <FormItem label="补证意见">
              {{ detail.additionalEvidSuggest }}
            </FormItem>
            <FormItem label="诉讼策略">
              {{ detail.litigationStrategy }}
            </FormItem>
            <FormItem label="风险提示">
              {{ detail.riskWarning }}
            </FormItem>
            <FormItem label="上传附件">
              <file-upload :default-list="developForm.attachmentList" :upload-config="{readOnly:true}" />
            </FormItem>
          </div>
        </Form>
        <div v-else class="no-tip">暂无配置信息</div>
      </div>
    </div>
    <!-- 项目经理配置 -->
    <div>
      <Row class="detail-header">
        <span>项目经理配置</span>
      </Row>
      <div>
        <Form v-if="projectPoint" :label-width="100" style="width:600px;">
          <FormItem label="建议起诉标的">
            <Row>
              {{ projectPoint.minAmount }}-{{ projectPoint.maxAmount }}
            </Row>
          </FormItem>
          <FormItem label="推荐管辖法院">
            <div>
              {{ projectPoint.courtJurisdiction }}
            </div>
          </FormItem>
          <FormItem label="补证意见">
            {{ projectPoint.additionalEvidSuggest }}
          </FormItem>
          <FormItem label="诉讼策略">
            {{ projectPoint.litigationStrategy }}
          </FormItem>
          <FormItem label="风险提示">
            {{ projectPoint.riskWarning }}
          </FormItem>
          <FormItem label="上传附件">
            <file-upload :default-list="projectForm.attachmentList" :upload-config="{readOnly:true}" />
          </FormItem>
        </Form>
        <div v-else class="no-tip">暂无配置信息</div>
      </div>
    </div>
  </div>
</template>

<script>
import styles from '@/assets/globalStyle.scss'
export default {
  filters: {
    lawyers: function(list) {
      if (list && list.length > 0) {
        const arr = list.map(item => {
          return item.teamName
        })
        return arr.join(',')
      }
      return ''
    }
  },
  props: {
    caseId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      styles,
      ifRead: true, // 是否只读
      ifChange: false, // 是否补充过
      ifAppoint: false, // 是否委派
      ifManager: false, // 是否研发
      ifDeveloper: false, // 是否项目经理
      viewRecord: false,
      assignTeamCtrl: false, // 推荐律师
      defaultTeamList: [],
      assignTeamArr: [], // 指派律师
      detail: {}, // 补充信息详情
      seriousLogs: [], // 重案修改记录
      developForm: {
        caseId: '',
        level: 'A',
        minAmount: '',
        maxAmount: '',
        participationLawsuit: '0',
        recommendLawyerList: [],
        suggestion: '',
        modifyRemark: '',
        attachmentList: []
      },
      ruleDevelop: {
        level: [
          { required: true, message: '请选择重要级别', trigger: 'change' }
        ],
        minAmount: [
          { required: true, message: '请输入最低价格', trigger: 'blur' }
        ],
        maxAmount: [
          { required: true, message: '请输入最高价格', trigger: 'blur' }
        ],
        participationLawsuit: [
          { required: true, message: '请选择是否参与诉讼', trigger: 'change' }
        ],
        // recommendLawyerList: [
        //   { required: true, type: 'array', min: 1, message: '请选择推荐律师', trigger: 'change' },
        //   { type: 'array', max: 5, message: '做多推荐5位律师', trigger: 'change' }
        // ],
        suggestion: [
          { required: true, message: '请输入研发意见', trigger: 'blur' }
        ],
        modifyRemark: [
          { required: true, message: '请输入修改理由', trigger: 'blur' }
        ]
      },
      projectForm: {
        caseId: '',
        teamId: '',
        teamType: ''
      },
      pointList: [],
      projectPoint: {}, // 指定律师
      loadingLawyer: false,
      loadingPoint: false
    }
  },
  mounted () {
    // 获取补充信息
    this.getAttachInfo()
    // 获取指定律师信息
    this.getAppointLawyer()
    this.developForm.caseId = this.caseId
    this.projectForm.caseId = this.caseId
  },
  methods: {
    checkRecord() {
      const url = `/business/serious/case/operate/log/${this.caseId}`
      this.$get(url).then(res => {
        this.seriousLogs = res.data
      })
      this.viewRecord = true
    },
    modify() {
      this.ifDeveloper = true
      this.ifManager = true
    },
    getAppointLawyer() {
      const url = `/business/serious/case/for/project/info/${this.caseId}`
      this.$get(url).then(res => {
        this.projectPoint = res.data
        this.ifAppoint = !!this.projectPoint
        this.projectForm = Object.assign(this.projectForm, this.projectPoint)
      })
    },
    getAttachmentList(arr) {
      const uploadList = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        if (item.id) { obj.id = item.id }
        uploadList.push(obj)
      })
      this.developForm.attachmentList = uploadList
    },
    selectLawyer(v) {
      if (v) {
        const lawyer = this.pointList.find(item => item.teamId == v)
        this.projectForm.teamType = lawyer.teamType
      }
    },
    appointLawyer() {
      const url = `/business/serious/case/appoint/Lawyer`
      const form = (({ caseId, teamId, teamType }) => ({ caseId, teamId, teamType }))(this.projectForm)
      if (this.ifAppoint) {
        this.$put(url, form).then(res => {
          if (res.code == 0) {
            this.$Message.success('修改成功')
          }
        })
      } else {
        this.$post(url, form).then(res => {
          if (res.code == 0) {
            this.$Message.success('添加成功')
          }
        })
      }
    },
    cancelAppoint() {
      this.projectForm.teamId = ''
    },
    getAttachInfo() { // 获取补充信息
      const url = `/business/serious/case/info/${this.caseId}`
      this.$get(url).then(res => {
        this.detail = res.data
        if (!this.detail) return false
        this.ifChange = !!this.detail.level// 判断是否为修改
        this.developForm = Object.assign(this.developForm, this.detail)
        this.developForm.participationLawsuit = this.developForm.participationLawsuit ? '1' : '0'
        this.assignTeamArr = this.detail.recommendLawyerList.map(item => {
          return {
            teamId: item.teamId,
            team: item.teamName,
            platformSourceType: item.teamType
          }
        })
        this.developForm.attachmentList = this.detail.attachmentList
        this.pointList = res.data.recommendLawyerList
      })
    },
    // 获取指派团队
    getIdList(data) {
      if (this.assignTeamArr.length > 5) {
        this.$Message.error('最多推荐5位')
        this.assignTeamArr.pop()
        return
      }
      this.assignTeamArr = data
    },
    // 确定
    confirm() {
      this.assignTeamCtrl = false
      this.defaultTeamList = this.assignTeamArr
    },
    // 取消
    cancel() {
      this.assignTeamCtrl = false
      this.assignTeamArr = this.defaultTeamList
    },
    // 清除指派团队
    clearAssignTeam(item, index) {
      this.assignTeamArr.splice(index, 1)
      this.defaultTeamList = this.assignTeamArr
    },
    submit() { // 重案信息提交
      const url = '/business/serious/case/info'
      const form = Object.assign({}, this.developForm)
      form.recommendLawyerList = this.assignTeamArr.map(item => {
        return {
          teamId: item.teamId,
          teamType: item.platformSourceType
        }
      })
      form.participationLawsuit = this.participationLawsuit > 0
      this.$refs['developForm'].validate((valid) => {
        if (valid) {
          if (this.ifChange) {
            // 修改
            this.$put(url, form).then(res => {
              if (res.code == 0) {
                this.$Message.success('修改成功')
              }
            })
          } else {
            // 新增
            this.$post(url, form).then(res => {
              if (res.code == 0) {
                this.$Message.success('添加成功')
              }
            })
          }
        }
      })
    },
    handleReset() {
      this.$refs['developForm'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/globalStyle.scss';
.container{
  padding:10px 20px;
  .detail-header{
    background: #fff;
    padding:5px 0 5px 10px;
    &::before{
      left:0;
    }
  }
  .attach-form{
    margin-left:20px;
  }
  .fix-record{
    margin-left:10px;
    font-size:12px;
    color:$globalMainColor;
    cursor:pointer;
  }
  .tag{
    height: auto;
    border: 1px solid #ebeaf0;
    padding: 4px 7px;
  }
  .no-tip{
    color:#ed3f14;
    margin-left:60px;
    font-size:14px;
  }
}
.time{
    font-size:16px;
}
</style>



// WEBPACK FOOTER //
// src/view/case/caseAttach.vue